import { getDefaultCheckoutLearnerCount } from '@coursera-web/wes-common';

import config from 'js/app/config';

import { ANNUALLY } from 'bundles/teams-v2/constants/billing';

const RESOURCE_ASSETS_URL = config.url.resource_assets;

export const MASTERCARD_ID = 'nYTCtPatEeqrqBIivh7_bQ';
export const VISA_ID = 's02LAPatEeqrqBIivh7_bQ';
export const CAPITAL_ONE_ID = '99lWBt3KEeuNpw7MyAzmlQ';

export const TEAMS_LOGO_URL = RESOURCE_ASSETS_URL + 'teams_landing/nav/C4T_logo_new.svg';

export const TEAMS_CONTACT_SALES_LINK = `${config.url.base}business/learn-more`;

// Default WES checkout query params (`learnerCount` from experiment-aware default in wes-common).
export const DEFAULT_QUERY = () => ({
  learnerCount: getDefaultCheckoutLearnerCount(),
  billingType: ANNUALLY,
});

export const PAGE_TYPE = {
  ACCOUNT: 'account',
  BILLING: 'billing',
} as const;

export type PageTypeValues = (typeof PAGE_TYPE)[keyof typeof PAGE_TYPE];
